import VisitSchedule from "./components/VisitSchedule.vue";
import MyVisit from "./components/MyVisit";
import Page404 from "./components/Page404";
import About from "./components/About";
import Guide from "./components/Guide";
import Objectives from "./components/Objectives";
import Feedback from './components/Feedback';

export default [
    { path: "/schedule/:id?", component: VisitSchedule },
    { path: "/visit", component: MyVisit },
    { path: "/about", component: About },
    { path: "/guide", component: Guide },
    { path: "/404", component: Page404 },
    { path: "/objectives", component: Objectives },
    { path: "/feedback", component: Feedback },
    {
        path: "/",
        redirect: "/schedule"
    },
    {
        path: "/visit/:?",
        redirect: "/visit"
    }
];
